<form *ngIf="form" [formGroup]="form">

  <section fxLayout="row" fxLayoutGap="8px">

    <div fxFlex="12.5" class="acess-per-pon">
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Access per PON</mat-label>
        <input #accessPerPon type="number" formControlName="accessPerPon" matInput>
      </mat-form-field>
      <app-suggestion [input]="accessPerPon" [options]="[32, 64, 128]"
        (changeSelection)="form.patchValue({accessPerPon: $event})">
      </app-suggestion>
    </div>
    <div fxFlex="12.5" class="max-bus-box-number">
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Bus box quantity</mat-label>
        <input #maxBoxesPerBus type="number" formControlName="max_boxes_per_bus" matInput>
      </mat-form-field>
      <mat-error i18n *ngIf="form.get('max_boxes_per_bus').hasError('max')">Maximum value must be 10</mat-error>
      <mat-error *ngIf="form.hasError('minMax')" i18n>Bus box quantity must be equal or greater than minimum
      </mat-error>
      <app-suggestion [input]="maxBoxesPerBus" [options]="[2, 4, 8]"
        (changeSelection)="form.patchValue({max_boxes_per_bus: $event})">
      </app-suggestion>
    </div>
    <div fxFlex="12.5" class="min-boxes-per-bus">
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Min bus box number</mat-label>
        <input #minBoxesPerBus type="number" formControlName="min_boxes_per_bus" matInput>
      </mat-form-field>
      <mat-error i18n *ngIf="form.get('min_boxes_per_bus').hasError('max')">Maximum value must be 10</mat-error>
      <app-suggestion [input]="minBoxesPerBus" [options]="[2, 4, 8]"
        (changeSelection)="form.patchValue({min_boxes_per_bus: $event})">
      </app-suggestion>
    </div>


    <mat-divider [vertical]="true"></mat-divider>

    <div fxFlex="25" fxLayout="column">
      <h3 i18n>Bus splitter types</h3>

      <div fxLayout="row" fxLayoutGap="4px">
        <mat-card fxFlex="50" class="info-card">
          <div class="title" i18n>Unbalanced</div>
          <div class="number">1x{{unbalanced}}</div>
        </mat-card>
        <mat-card fxFlex="50" class="info-card">
          <div class="title" i18n>Attendance splitter</div>
          <div class="number">1x{{attendanceSplitter}}</div>
        </mat-card>
      </div>
    </div>

    <mat-divider [vertical]="true"></mat-divider>

    <div fxFlex="37.5" fxLayout="column">
      <h3 i18n>Splitter sections beyond bus</h3>

      <app-input-array #sectionsInput fxFlex="100" [values]="sections" (valuesChange)="sectionsChange($event)"
        label="Section" i18n-label>
        <mat-error *ngIf="sectionsError else sectionEmptyBlock" i18n>
          Bus box quantity, attendance splitter and splitter sections does not match with Access per PON
        </mat-error>
      </app-input-array>
      <app-suggestion *ngIf="sectionsInput.index != null" [options]="allowedSplitterValues"
        (changeSelection)="sections[sectionsInput.index] = $event">
      </app-suggestion>

    </div>

  </section>

  <h3>Overbooking</h3>
  <div fxLayout="row wrap">
    <div fxFlex="25">
      <mat-form-field class="app-block" appearance="outline">
        <input type="number" matInput formControlName="overbooking">
        <span matSuffix>%</span>
      </mat-form-field>
    </div>
    <div fxFlex="100"></div>
    <mat-slider class="overbooking-slider" fxFlex="25" [value]="this.form.value.overbooking"
      (input)="this.form.patchValue({overbooking: $event.value})" tickInterval="1" step="1" min="0" max="100">
    </mat-slider>
  </div>

  <section fxLayout="row" fxLayoutGap="4px">

    <div fxFlex="80">
      <h3 i18n>Boxes</h3>

      <app-input-array #boxInput [canDelete]="false" [values]="boxs" i18n-label label="Box"
        (valuesChange)="boxsChange($event)">
        <mat-error i18n *ngIf="form.get('boxArray').invalid">Fill all boxes with the allowed values</mat-error>
      </app-input-array>

      <div>
        <app-suggestion *ngIf="boxInput.index != null"
          [options]="allowedBoxValues"
          (changeSelection)="boxs[boxInput.index] = $event">
        </app-suggestion>
      </div>

    </div>
    <div>
      <mat-card class="info-card">
        <div class="title" i18n>Last box</div>
        <div class="number">{{lastBox}}</div>
      </mat-card>
    </div>

    <mat-divider [vertical]="true"></mat-divider>

    <div fxFlex class="max-distance-between-boxes">
      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Max length beetwen boxes</mat-label>
        <input #maxDistanceBetweenBoxes type="number" formControlName="max_distance_between_boxes" matInput>
        <mat-hint i18n>Meters</mat-hint>
      </mat-form-field>
      <div>
        <app-suggestion [input]="maxDistanceBetweenBoxes" [options]="[80, 180, 280, 380, 480, 580]"
          (changeSelection)="form.patchValue({max_distance_between_boxes: $event})">
        </app-suggestion>
      </div>
    </div>
  </section>

  <section fxLayout="row wrap">
    <h3 fxFlex="100" i18n>Customer connection</h3>
    <mat-form-field appearance="outline" fxFlex="25">
      <mat-label i18n>Max length drop cable</mat-label>
      <input #maxDropLength type="number" formControlName="max_drop_length" matInput>
      <mat-hint i18n>Meters</mat-hint>
    </mat-form-field>
    <div fxFlex></div>
    <div fxFlex="100">
      <app-suggestion [input]="maxDropLength" [options]="['80', '100', '120', '150']"
        (changeSelection)="form.patchValue({max_drop_length: $event})">
      </app-suggestion>
    </div>

  </section>

  <section>
    <h3 i18n>Box-Drop</h3>
    <mat-button-toggle-group formControlName="connector_box_drop" class="options">
      <mat-button-toggle value="factory_connector" i18n>FACTORY</mat-button-toggle>
      <mat-button-toggle value="field_connector" i18n>FIELD</mat-button-toggle>
      <mat-button-toggle value="fusion" i18n>FUSION</mat-button-toggle>
    </mat-button-toggle-group>

  </section>

  <section>
    <app-fiber-connection [form]="form" [settings]="parameters.horizontal_settings"></app-fiber-connection>
  </section>

</form>

<ng-template #sectionEmptyBlock>
  <mat-hint i18n>Optional</mat-hint>
</ng-template>
